import React from 'react';
import ReactDOM from 'react-dom';
import DeckGL from "deck.gl";
import {WebMercatorViewport} from 'deck.gl';
import {GeoJsonLayer, IconLayer, TextLayer} from 'deck.gl'
import { _MapContext as MapContext, StaticMap, Popup, ScaleControl, AttributionControl, FullscreenControl, NavigationControl } from "react-map-gl";

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import custom_pin from "composer/images/pins/pin.png";

import {useDebounce} from 'react-use';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Rectangle,
  InfoWindow,
} from "react-google-maps";
import MarkerWithLabel from "react-google-maps/lib/components/addons/MarkerWithLabel"

import { Icon, IconButton, Tooltip } from '@material-ui/core'

// import other components within the same project here
import Config from "composer/Config.jsx";
import Localization from "composer/Localization.jsx"

class LocaleMapView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      map: {
        zoom: 0,
        center: {
          lat: 0,
          lon: 0
        },
        bounds:{
          ul:{
            lat: 0,
            lon: 0
          },
          br:{
            lat: 0,
            lon: 0
          }
        },
        style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
        _style: "mono",
        lang: "zh"
      },
      // localeMarkerID: -1,
      width: 0,
      height: 0,
      popup_data: {
        show: false,
        lat: 0,
        lon: 0,
        meta: null,
        index: -1
      }
    };
    autoBind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let boundingRect = this.props.parent.refs.localeViewerBar.refs.div.getBoundingClientRect();
    let height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height);
    this.setState({
      width: window.innerWidth,
      height: height,
    });
    this.state.width = window.innerWidth;
    this.state.height = height;
  }

  localeMarkerClicked(locale) {
    let position = {
      lat: parseFloat(locale['mid_lat']),
      lng: parseFloat(locale['mid_lon'])
    };
    this.props.parent.updateMapState();
  }

  onMapMounted = (map) => {
    this.state.map = map;
  }

  onZoomChanged() {
    let zoom = this.state.map.getZoom();
    this.props.parent.refreshLocaleList();
  }

  onBoundsChanged() {
    let bounds = this.state.map.getBounds();
    this.props.parent.refs.localeMapState.setState({ bounds: bounds });
    this.props.parent.refs.localeMapState.state.bounds = bounds;
  }

  onDragEnd() {
    this.props.parent.refreshLocaleList();
    // this.setState({ localeMarkerID: -1 });
    // this.state.localeMarkerID = -1;
  }

  onMapTypeIdChanged() {
    let mapType = this.state.map.getMapTypeId();
    this.props.parent.refs.localeMapState.setState({ mapTypeId: mapType });
    this.props.parent.refs.localeMapState.state.mapTypeId = mapType;
  }

  checkWithinMapBounds(lat, lng) {
    let result = false;
    let bounds = this.props.parent.refs.localeMapState.state.bounds;
    if (bounds != null) {
      if(lat >= bounds.getSouthWest().lat() && lat <= bounds.getNorthEast().lat() && lng >= bounds.getSouthWest().lng() && lng <= bounds.getNorthEast().lng()) {
        result = true;
      }
    }
    return result;
  }

  infoWindowCloseClicked() {
    this.props.parent.updateMapState();
    // this.setState({ localeMarkerID: -1 });
    // this.state.localeMarkerID = -1;
  }

  editLocaleClicked(index) {
    this.props.parent.editLocaleByIndex(index);
  }

  infoLocaleClicked(index) {
    this.props.parent.showLocaleInfo(index);
  }

  retrieveAnswerClicked(index) {
    this.props.parent.retrieveAnswerByIndex(index);
  }

  deleteLocaleClicked(id) {
    this.props.parent.deleteLocale(id);
  }

  genBoxData(){
    var boxData = []
    for(var i = 0; i<this.props.parent.state.localeListInMap.length; i++){
      boxData.push({
        'type': 'Feature',
        'color': parseInt(this.props.parent.state.localeListInMap[i].color).toString(16),
        'geometry': {
          'type': 'Polygon',
          'coordinates': [[
            [parseFloat(this.props.parent.state.localeListInMap[i].ul_lon), parseFloat(this.props.parent.state.localeListInMap[i].ul_lat)],
            [parseFloat(this.props.parent.state.localeListInMap[i].ul_lon), parseFloat(this.props.parent.state.localeListInMap[i].br_lat)],
            [parseFloat(this.props.parent.state.localeListInMap[i].br_lon), parseFloat(this.props.parent.state.localeListInMap[i].br_lat)],
            [parseFloat(this.props.parent.state.localeListInMap[i].br_lon), parseFloat(this.props.parent.state.localeListInMap[i].ul_lat)],
            [parseFloat(this.props.parent.state.localeListInMap[i].ul_lon), parseFloat(this.props.parent.state.localeListInMap[i].ul_lat)]
          ]]
        }
      });
    }
    var boxLayers = new GeoJsonLayer({
        id: 'geojson-layer',
        data: boxData,
        lineWidthScale: 4,
        opacity: 0.4,
        filled: true,
        stroked: true,
        lineWidth: 2,
        lineWidthMinPixels: 2,
        wireframe: true,
        // autoHighlight: true,
        getLineColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0];
        },
        getFillColor: f => {
          var hex = f.color;
          while(hex.length != 6){
            hex = '0' + hex;
          }
          hex = hex + '1f';
          // convert to RGB
          return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
        },
        pickable: true,
      });

      return boxLayers
  }

  genIconLayer(){
    var iconData = []
    for(var i = 0; i<this.props.parent.state.localeListInMap.length; i++){
      iconData.push({
        'color': parseInt(this.props.parent.state.localeListInMap[i].color).toString(16),
        'coordinates': [(parseFloat(this.props.parent.state.localeListInMap[i].ul_lon) + parseFloat(this.props.parent.state.localeListInMap[i].br_lon))/2, (parseFloat(this.props.parent.state.localeListInMap[i].ul_lat) + parseFloat(this.props.parent.state.localeListInMap[i].br_lat))/2],
        'meta': this.props.parent.state.localeListInMap[i]
      });
    }

    const ICON_MAPPING = {
      marker: {
        x: 0,
        y: 0,
        width: 57,
        height: 80,
        anchorY: 80,
        mask: true
      }
    };

    var iconLayers = new IconLayer({
      id: 'icon-layer',
      data: iconData,
      pickable: true,
      autoHighlight: true,
      iconAtlas: custom_pin,
      iconMapping: ICON_MAPPING,
      getIcon: d => 'marker',
  
      sizeScale: 15,
      getPosition: d => d.coordinates,
      getSize: d => 5,
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      onClick: (info, event) => {
        if(info.object){
          console.log('index assigned normally');
          this.setState({
            popup_data:{
              show: true,
              lat: info.object.coordinates[1],
              lon: info.object.coordinates[0],
              meta: info.object.meta,
              index: info.index
            }
          });
          this.state.popup_data = {
            show: true,
            lat: info.object.coordinates[1],
            lon: info.object.coordinates[0],
            meta: info.object.meta,
            index: info.index
          }
        }else{
          console.log('index assigned -1');
          this.setState({
            popup_data:{
              show: false,
              lat: 0,
              lon: 0,
              meta: null,
              index: -1
            }
          });
          this.state.popup_data = {
            show: false,
            lat: 0,
            lon: 0,
            meta: null,
            index: -1
          }
        }
      }
    });

    return iconLayers;
  }
  
  genTextLayer(){
    var textData = []
    var charSet = ''
    for(var i = 0; i<this.props.parent.state.localeListInMap.length; i++){
      textData.push({
        'color': parseInt(this.props.parent.state.localeListInMap[i].color).toString(16),
        //'name': ' ' + this.props.parent.state.localeListInMap[i].name + ' ',
        'name': this.props.parent.state.localeListInMap[i].name.length >= 15 ? this.props.parent.state.localeListInMap[i].name.substring(0, 15)+ '...' : (this.props.parent.state.localeListInMap[i].name),
        'coordinates': [(parseFloat(this.props.parent.state.localeListInMap[i].ul_lon) + parseFloat(this.props.parent.state.localeListInMap[i].br_lon))/2, (parseFloat(this.props.parent.state.localeListInMap[i].ul_lat) + parseFloat(this.props.parent.state.localeListInMap[i].br_lat))/2]
      });
      if( this.props.parent.state.localeListInMap[i].name.length >= 15){
        charSet = charSet + this.props.parent.state.localeListInMap[i].name + '...';
      }else{
        charSet = charSet + this.props.parent.state.localeListInMap[i].name;
      }
    }
    var textLayers = new TextLayer({
      id: 'TextLayer',
      data: textData,
      background: true,
      backgroundColor: [255, 255, 255, 150], //cannot use alpha channel
      backgroundPadding: [5, 5, 5, 5],
      characterSet: charSet.split(''),
      // fontSettings: {
      //   'fontSize': 100,
      // },
      // fontWeight: 100,
      getAlignmentBaseline: 'top',
      getAngle: 0,
      // getColor: [255, 255, 255],
      getColor: f => {
        var hex = f.color;
        while(hex.length != 6){
          hex = '0' + hex;
        }
        // convert to RGB
        return hex ? hex.match(/[0-9a-f]{2}/g).map(x => parseInt(x, 16)) : [0, 0, 0, 0];
      },
      getPosition: d => d.coordinates,
      getSize: 12,
      getText: d => d.name,
      getTextAnchor: 'middle',
      lineHeight: 1,
      sizeScale: 1,
      pickable: true,
    });

    return textLayers;
  }
  render() {
    const initialViewState = {
      longitude: this.props.parent.refs.localeMapState.state.center.lng,
      latitude: this.props.parent.refs.localeMapState.state.center.lat,
      zoom: this.props.parent.refs.localeMapState.state.zoom,
      bearing: 0,
      pitch: 0
    };

    const { map } = this.state;

    this.state.map.zoom = this.props.parent.refs.localeMapState.state.zoom;
    this.state.map.center.lon = this.props.parent.refs.localeMapState.state.center.lng;
    this.state.map.center.lat = this.props.parent.refs.localeMapState.state.center.lat;

    if(Localization.strings.getLanguage() != this.state.map.lang){
      this.state.map.lang = Localization.strings.getLanguage();
      switch(this.state.map._style){
        case "mono":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
              _style: "mono"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
          this.state.map._style = "mono";
          break;
        case "satellite":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
              _style: "satellite"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
          this.state.map._style = "satellite";
          break;
        case "cartoon":
          this.setState({
            map:{
              ...this.state.map,
              style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
              _style: "cartoon"
            }
          });
          this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
          this.state.map._style = "cartoon";
          break;
      }
    }

    const boxLayers = this.genBoxData();
    const iconLayers = this.genIconLayer();
    const textLayers = this.genTextLayer();

    return (
      <div style={{position:"relative"}}>
        <DeckGL
          initialViewState={initialViewState} 
          ContextProvider={MapContext.Provider}
          controller={true} height={this.state.height} 
          top="50px" position="relative" 
          layers={[boxLayers, iconLayers, textLayers]}
          onViewStateChange={(viewState =>{
            if (viewState.interactionState){
              if (!viewState.interactionState.isDragging && !viewState.interactionState.isRotating){
                const viewport = new WebMercatorViewport(viewState.viewState);
                const ul = viewport.unproject([0, 0]);
                const br = viewport.unproject([this.state.width, this.state.height], false);
                // update map's field here (center...)
                this.state.map.zoom = viewState.viewState.zoom;
                this.state.map.center.lon = viewState.viewState.longitude;
                this.state.map.center.lat = viewState.viewState.latitude;
                this.state.map.bounds.ul.lon = ul[0];
                this.state.map.bounds.ul.lat = ul[1];
                this.state.map.bounds.br.lon = br[0];
                this.state.map.bounds.br.lat = br[1];
                setTimeout(()=>{
                  this.onDragEnd();
                }, 500);
              }
            }
          })}
        >
          <StaticMap mapStyle={map.style} mapboxApiAccessToken={Config.MBOX_KEY()} attributionControl={false}/>
          <ButtonGroup style={{top:10, left:10, position:"relative"}} size="small" variant="contained" color="primary" aria-label="contained primary button group">
            <Button color={this.state.map._style=="mono"? "secondary":"primary"} onClick={
              () => {
                this.setState({
                  map:{
                    ...this.state.map,
                    style: Config.MBOX_STYLE(Localization.strings.getLanguage()).mono,
                    _style: "mono"
                  }
                });
                this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).mono;
                this.state.map._style = "mono";
              }
            }>MONO</Button>
            <Button color={this.state.map._style=="satellite"? "secondary":"primary"} onClick={
              () => {
                this.setState({
                  map:{
                    ...this.state.map,
                    style: Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite,
                    _style: "satellite"
                  }
                });
                this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).satellite;
                this.state.map._style = "satellite";
              }
            }>SATELLITE</Button>
            <Button color={this.state.map._style=="cartoon"? "secondary":"primary"} onClick={
              () => {
                this.setState({
                  map:{
                    ...this.state.map,
                    style: Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon,
                    _style: "cartoon"
                  }
                });
                this.state.map.style = Config.MBOX_STYLE(Localization.strings.getLanguage()).cartoon;
                this.state.map._style = "cartoon";
              }
            }>VECTOR</Button>
          </ButtonGroup>
          {this.state.popup_data.show && <Popup 
            latitude={this.state.popup_data.lat}
            longitude={this.state.popup_data.lon}
            closeButton={true}
            closeOnClick={true}
            onClose={() => this.setState({popup_data: {
              ...this.state.popup_data,
              show: false
            }})}
            anchor='top'
          >
            <ButtonGroup variant="text" color="primary" aria-label="text primary button group">
              <Tooltip title={Localization.strings.EDIT} placement="left-end">
                <IconButton onClick={()=>{
                  this.setState({popup_data: {
                    ...this.state.popup_data,
                    show: false
                  }});
                  this.editLocaleClicked(this.state.popup_data.index);
                  }}
                  disabled={!(this.props.root.getSameSchoolEdit() || this.props.root.getMyUserId() == this.state.popup_data.meta.user_id)}
                  aria-label="Edit">
                  <Icon>edit</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title={Localization.strings.VIEW_EDIT_DETAILS} placement="bottom-end">
                <IconButton onClick={()=>{
                  this.setState({popup_data: {
                    ...this.state.popup_data,
                    show: false
                  }});
                  this.infoLocaleClicked(this.state.popup_data.index);
                  }}
                  disabled={!(this.props.root.getSameSchoolEdit() || this.props.root.getMyUserId() == this.state.popup_data.meta.user_id)}  
                  aria-label="View">
                  <Icon>info</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title={Localization.strings.RETRIEVE_ANSWERS} placement="bottom-start">
                <IconButton onClick={()=>{
                  this.setState({popup_data: {
                    ...this.state.popup_data,
                    show: false
                  }});
                  this.retrieveAnswerClicked(this.state.popup_data.index);
                  }}
                  aria-label="Retrieve">
                  <Icon>assessment</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title={Localization.strings.DELETE} placement="right-end">
                <IconButton onClick={()=>{
                  this.setState({popup_data: {
                    ...this.state.popup_data,
                    show: false
                  }});
                  this.deleteLocaleClicked(this.state.popup_data.index);
                  }}  
                  disabled={!(this.props.root.getSameSchoolEdit() || this.props.root.getMyUserId() == this.state.popup_data.meta.user_id)}
                  aria-label="Del">
                  <Icon>delete</Icon>
                </IconButton>
              </Tooltip>
            </ButtonGroup>
          </Popup>}
          <NavigationControl style={{top:10, right:10}} showCompass={false}/>
        </DeckGL>
      </div>
    )
  ;}
}
export default LocaleMapView;
